export const LoadingState = ({ label = 'Loading…' }) => (
  <div className="state state--loading" role="status"><span className="spinner" aria-hidden="true" />{label}</div>
);

export const ErrorState = ({ title = 'Something went wrong', message, onRetry }) => (
  <div className="state state--error" role="alert">
    <strong>{title}</strong><p>{message || 'Try the request again.'}</p>
    {onRetry && <button className="button button--secondary" type="button" onClick={onRetry}>Try again</button>}
  </div>
);

export const EmptyState = ({ title, message, action }) => (
  <div className="state state--empty"><strong>{title}</strong><p>{message}</p>{action}</div>
);

export const StatusBadge = ({ active }) => <span className={`status-badge ${active ? 'is-active' : 'is-inactive'}`}>{active ? 'Active' : 'Inactive'}</span>;

